export default "__VITE_ASSET__841020ce__"